import { render, staticRenderFns } from "./CouponExpired.vue?vue&type=template&id=59385466&scoped=true"
import script from "./CouponExpired.vue?vue&type=script&lang=js"
export * from "./CouponExpired.vue?vue&type=script&lang=js"
import style0 from "./CouponExpired.vue?vue&type=style&index=0&id=59385466&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59385466",
  null
  
)

export default component.exports